module.exports = "<input type=\"checkbox\"\n       [id]=\"id\"\n       [name]=\"name\"\n       [disabled]=\"disabled\"\n       [(ngModel)]=\"innerValue\">\n<label [for]=\"id\"\n       [attr.id]=\"'label-' + id\"\n       [class.animation]=\"animation\"></label>\n<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-switcher/ui-switcher.html
// module id = 1088
// module chunks = 3